import React, { useState } from "react";
import Navbar from "../../commanComponents/Navbar";
import { useForm } from "react-hook-form";
import { InputBox } from "../../commanComponents/inputs/InputBox";
import "./user.css";
import BlueHeading from "../../commanComponents/BlueHeading";
import SelectBox from "../../commanComponents/selects/SelectBox";
import { useNavigate, useSearchParams } from "react-router-dom";
import ColorBtn from "../../commanComponents/buttons/ColorBtn";
import Header from "../../commanComponents/Header";
import BackButton from "../../commanComponents/buttons/BackButton";
import { communication } from "../../constants/apis/communication";
import toast from "react-hot-toast";
import { useMutation, useQuery } from "react-query";
import Loader from "../../commanComponents/Loader";

const CreateUser = () => {
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("userId");
  const page = searchParams.get("page");
  const [tabAccess, setTabAccess] = useState([
    { tab: "Activity Sheet/ Attendance", tabName: "activity-attendance", access: "" },
    // { tab: "Logbook", tabName: "logbook", access: "" },
    // { tab: "SDL", tabName: "sdl", access: "" },
    // { tab: "LHD", tabName: "lhd", access: "" },
    // { tab: "Battery Locomotive", tabName: "battery-locomotive", access: "" },
    // { tab: "Loader", tabName: "loader", access: "" },
    // { tab: "Compressor", tabName: "compressor", access: "" },
    // { tab: "Hydraulic Excavator", tabName: "hydraulic-excavator", access: "" },
    // { tab: "Drill Machine", tabName: "drill-machine", access: "" },
    // { tab: "Dumpers", tabName: "dumpers", access: "" },
    // { tab: "Dozer", tabName: "dozer", access: "" },
    // { tab: "Other (Grader/Generator/Crane/Other)", tabName: "other", access: "" },
  ]);
  const [employeeGroup, setEmployeeGroup] = useState(null);
  const [department, setDepartment] = useState(null);
  const [departmentError, setDepartmentError] = useState(null);
  const [designationError, setDesignationError] = useState(null);
  const [selectedDesignation, setSelectedDesignation] = useState(null);
  const [departmentList, setepartmentList] = useState(null);
  const [designations, setDesignations] = useState(null);
  const [employeeGroupError, setEmployeeGroupError] = useState(null);

  const employeeGroupOptions = [
    { label: "executive", value: "executive" },
    { label: "non - executive", value: "non - executive" },
  ];

  const { mutate, isLoading } = useMutation(
    (data) => {
      if (userId) {
        return communication?.updateUser({ ...data, userId });
      } else {
        return communication?.createUser(data);
      }
    },
    {
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        if (data?.data?.status === "SUCCESS") {
          toast.success(`Success : ${data?.data?.message}`);
          navigate(-1);
        } else {
          toast.error(`Failed : ${data?.data?.message}`);
        }
      },
      onError: (error) => {
        toast.error(`Failed to update status: ${error?.message}`);
      },
    }
  );

  const { data: userData, isFetching } = useQuery(["getUserById"], () => communication?.getUserById(userId), {
    refetchOnWindowFocus: false,
    enabled: userId ? true : false,
    onSuccess: (data) => {
      if (data?.data?.status == "SUCCESS") {
        setValue("name", data?.data?.result?.name);
        setValue("employee_no", data?.data?.result?.userId);
        setEmployeeGroup({ label: data?.data?.result?.employee_group, value: data?.data?.result?.employee_group });
        const userDesig = data?.data?.result?.designation;
        if (Array.isArray(userDesig)) {
          setSelectedDesignation(userDesig.map((d) => ({ label: d, value: d })));
        } else if (userDesig) {
          setSelectedDesignation({ label: userDesig, value: userDesig });
        } else {
          setSelectedDesignation(null);
        }
        setValue("phoneNumber", data?.data?.result?.phoneNumber);
        setDepartment({ label: data?.data?.result?.department, value: data?.data?.result?.department });
        const tabAccessFromBE = tabAccess?.map((ele) => {
          const findTab = data?.data?.result?.tabAccess?.find((item) => item?.tabName === ele?.tabName);
          if (findTab) {
            return { ...ele, access: findTab?.access };
          }
          return ele; // Ensure all elements are returned
        });

        setTabAccess(tabAccessFromBE);
      } else if (data?.data?.status == "JWT_INVALID") {
        toast.error(`Failed: ${data?.data?.message}`);
      } else if (data?.data?.status == "FAILED") {
        toast.error(`Failed: ${data?.data?.message}`);
      }
    },
    onError: (error) => {
      toast.error(`Failed: ${error?.message}`);
    },
  });
  const { isFetching: fetchingDesignationList } = useQuery(["getUserDesignationList"], () => communication?.getUserDesignationList(), {
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      if (data?.data?.status == "SUCCESS") {
        const designationData = data?.data?.designation?.map((ele) => {
          return { label: ele, value: ele };
        });
        setDesignations(designationData);
      } else if (data?.data?.status == "JWT_INVALID") {
        toast.error(`Failed: ${data?.data?.message}`);
      } else if (data?.data?.status == "FAILED") {
        toast.error(`Failed: ${data?.data?.message}`);
      }
    },
    onError: (error) => {
      toast.error(`Failed: ${error?.message}`);
    },
  });

  const { isFetching: getAllDepartmentList } = useQuery(["getAllDepartmentList"], () => communication?.getAllDepartmentList(), {
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      if (data?.data?.status == "SUCCESS") {
        const deptData = data?.data?.department?.map((ele) => {
          return { label: ele, value: ele };
        });
        setepartmentList(deptData);
      } else if (data?.data?.status == "JWT_INVALID") {
        toast.error(`Failed: ${data?.data?.message}`);
      } else if (data?.data?.status == "FAILED") {
        toast.error(`Failed: ${data?.data?.message}`);
      }
    },
    onError: (error) => {
      toast.error(`Failed: ${error?.message}`);
    },
  });

  const handleCreateUser = (data) => {
    const filteredTabAccess = tabAccess?.filter((ele) => {
      return (ele?.access == "read" || ele?.access == "write") && { tabName: ele?.tabName, access: ele?.access };
    });
    const requiredTabAccessParameters = filteredTabAccess?.map((ele) => {
      return { tabName: ele?.tabName, access: ele?.access };
    });
    const selectedDesignationValue = Array.isArray(selectedDesignation) ? selectedDesignation.map((d) => d.value) : selectedDesignation ? [selectedDesignation.value] : [];
    const dataToSend = { ...data, department: department?.value, employee_group: employeeGroup?.value, tabAccess: requiredTabAccessParameters, designation: selectedDesignationValue };
    mutate(dataToSend);
  };

  const handleTabPermissionChange = (index, access) => {
    const updatedTabs = [...tabAccess];
    updatedTabs[index].access = access;
    setTabAccess(updatedTabs);
  };

  return (
    <div>
      {(isLoading || isFetching) && <Loader />}
      <Navbar heading={userId ? "Update User" : "Create User"} showBackBtn={true} />
      <Header>
        <div className="d-flex justify-content-end w-100">
          <BackButton />
        </div>
      </Header>
      <div className="filterWrapper comman-box-shadow">
        <BlueHeading text={"User Details"} />
        <div>
          <InputBox
            disabled={userId}
            style={{ textTransform: "capitalize" }}
            label="User Name *"
            placeholder="Enter User Name"
            register={{ ...register("name", { required: "Name is Required" }) }}
            errorMessage={errors?.name}
          />
          <InputBox
            disabled={userId}
            label="Employee No.*"
            type="number"
            placeholder="Enter Employee No"
            register={{ ...register("employee_no", { required: "Employee No Id is Required" }) }}
            errorMessage={errors?.employee_no}
          />
          <SelectBox
            value={selectedDesignation}
            isMulti={true}
            label={"Designation*"}
            isLoading={fetchingDesignationList}
            isDisabled={fetchingDesignationList || userId ? true : false}
            onChange={(e) => {
              setSelectedDesignation(e);
              setDesignationError("");
            }}
            options={designations}
            placeholder={"Select Designation"}
            errorMessage={designationError}
          />
          <InputBox
            disabled={userId}
            label="Phone Number*"
            style={{ textTransform: "capitalize" }}
            type="number"
            placeholder="Enter Phone Number"
            register={register("phoneNumber", {
              required: "Phone Number is Required",
              pattern: {
                value: /^[0-9]\d{9}$/,
                message: "Enter a valid Phone number (10 digits)",
              },
            })}
            errorMessage={errors?.phoneNumber}
          />
          <SelectBox
            value={department}
            label={"Department*"}
            onChange={(e) => {
              setDepartment(e);
              setDepartmentError("");
            }}
            options={departmentList}
            placeholder={"Enter Department"}
            isDisabled={userId}
            errorMessage={departmentError}
          />
          <SelectBox
            value={employeeGroup}
            label={"Employee Group*"}
            onChange={(e) => {
              setEmployeeGroup(e);
              setEmployeeGroupError("");
            }}
            options={employeeGroupOptions}
            placeholder={"Select Employee Group"}
            isDisabled={userId}
            errorMessage={employeeGroupError}
          />
        </div>
      </div>

      <div className="cardWrapper comman-box-shadow">
        <div>
          <BlueHeading text={"Tab Access"} />
        </div>
        <div className="tabAccessTableWrapper">
          <table>
            <tbody>
              {tabAccess?.map((ele, index) => {
                return (
                  <tr>
                    <td className="text-center col_300px">{ele?.tab}</td>
                    <td className="col_150px">
                      <div className="d-flex gap-2 justify-content-center">
                        <input
                          type="radio"
                          disabled={page == "view"}
                          name={`tab-${index}`}
                          className="form-check-input cursor-pointer"
                          checked={ele?.access == "write"}
                          style={{ border: "1px solid gray" }}
                          onChange={() => handleTabPermissionChange(index, "write")}
                        />
                        <p>Write</p>
                      </div>
                    </td>
                    <td className="col_150px">
                      <div className="d-flex gap-2 justify-content-center">
                        <input
                          type="radio"
                          disabled={page == "view"}
                          name={`tab-${index}`}
                          className="form-check-input cursor-pointer"
                          checked={ele?.access == "read"}
                          style={{ border: "1px solid gray" }}
                          onChange={() => handleTabPermissionChange(index, "read")}
                        />
                        <p>Read</p>
                      </div>
                    </td>
                    <td className="col_150px">
                      <div className="d-flex gap-2 justify-content-center align-items-center">
                        <input
                          type="radio"
                          disabled={page == "view"}
                          name={`tab-${index}`}
                          className="form-check-input cursor-pointer"
                          checked={ele?.access == "none"}
                          style={{ border: "1px solid gray" }}
                          onChange={() => handleTabPermissionChange(index, "none")}
                        />
                        <p>None</p>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      <div className="submitBtnWrapper">
        <ColorBtn text={"Cancel"} color={"rgba(96, 91, 255, 1)"} onClick={() => navigate(-1)} />
        {page !== "view" && (
          <ColorBtn
            onClick={() => {
              if (!department) {
                setDepartmentError("Department is required");
              }
              if (!selectedDesignation) {
                setDesignationError("Designation is required");
              }
              if (!employeeGroup) {
                setEmployeeGroupError("Employee-group is required");
              }
              handleSubmit(handleCreateUser)();
            }}
            bgColor={"#34c759"}
            color={"#fff"}
            text={"Submit"}
          />
        )}
      </div>
    </div>
  );
};

export default CreateUser;
